<template>
  <div class="p-8" id="invoice">
    <div v-if="facts && facts.length > 0">
      <h2 class="title font-neue font-bold">MES REMBOURSEMENTS</h2>
      <div class="hidden lg:block mt-4">
        <vue-good-table
          :pagination-options="paginationOptions"
          :columns="columns"
          :rows="facts"
          styleClass="vgt-table "
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'date'">
              {{ props.row.date | formatdate }}
            </span>
            <span v-if="props.column.field == 'uid'">
              {{ props.row.input_text ?? props.row.uid }}
            </span>
            <span v-if="props.column.field == 'receipt' && !disable_doc">
              <a
                :href="props.row.id_proof"
                target="_blank"
                class="text-blue-500"
                >Voir le document</a
              >
            </span>
            <span v-if="props.column.field == 'participationValide'">
              <p v-html="formatStatus(props.row.participationValide)" />
            </span>
            <span
              class="text-red-500 text-sm"
              v-if="
                props.column.field == 'motif_nc' &&
                props.row.participationValide != 'VALID'
              "
            >
              {{ props.row.motif_nc }}
            </span>
            <span v-if="props.column.field == 'quantity'">
              {{ calculateTotalQuantity(props.row.prix_produits) }}
            </span>
            <p v-if="props.column.field == 'prix_produits'">
              <span
                v-if="
                  props.row.participationValide === 'VALID' ||
                  props.row.participationValide === 'REFUND_DONE'
                "
                >{{ props.row.amount_to_refund / 100 || 0 }} &euro;</span
              >
            </p>
            <span
              v-if="
                props.column.field == 'amount_to_refund' &&
                props.row.participationValide != 'REFUND_DONE' &&
                props.row.participationValide != 'MISSING' &&
                props.row.participationValide != 'INVALID'
              "
            >
              <span>{{ props.row.amount_to_refund || 0 }} &euro;</span>
            </span>
            <span
              v-if="
                points &&
                props.column.field == 'points' &&
                props.row.participationValide != 'REFUND_DONE' &&
                props.row.participationValide != 'MISSING' &&
                props.row.participationValide != 'INVALID'
              "
            >
              <span v-if="props.row.participationValide === 'VALID'">
                {{ props.row.amount_to_refund || 0 }} &euro;</span
              >
            </span>
          </template>
        </vue-good-table>
      </div>

      <div v-if="facts.length > 0" class="lg:hidden block relative">
        <div class="entetes">
          <div class="th">Date</div>
          <div v-if="!disable_doc" class="th">Document</div>
          <div class="th">Référence</div>
          <div class="th">Statut</div>
          <div class="th">Motif</div>
          <div class="th">Quantité</div>
          <div class="th">Montant</div>
        </div>

        <div id="box">
          <div class="item" v-for="item in facts" :key="item.index">
            <div class="th text-center border-l-2 border-white">
              {{ item.date | formatdate }}
            </div>
            <div
              v-if="!disable_doc"
              class="th text-center border-l-2 border-white"
            >
              <a :href="item.id_proof" target="_blank" class="text-blue-500">
                Voir le document
              </a>
            </div>
            <div class="th text-left border-l-2 border-white">
              {{ item.uid }}
            </div>
            <div class="th text-center border-l-2 border-white">
              <p v-html="formatStatus(item.participationValide)" />
            </div>
            <div class="th text-left border-l-2 border-white">
              {{ item.motif_nc }}
            </div>
            <div class="th text-center border-l-2 border-white">
              {{ calculateTotalQuantity(item.prix_produits) }}
            </div>
            <div class="th text-center border-l-2 border-white overflow-x-auto">
              {{ item.amount_to_refund || 0 }} &euro;
            </div>
            <div
              v-if="points"
              class="th text-center border-l-2 border-white overflow-x-auto"
            >
              <span
                v-if="
                  item.participationValide === 'VALID' ||
                  item.participationValide === 'REFUND_DONE'
                "
                >{{ item.amount_to_refund || 0 }} &euro;</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import axios from "axios";

export default {
  data() {
    return {
      amount_to_refund: 0,
      paginationOptions: {},
      columns: [],
      facts: {},
      remaining: 100,
      sommeValid: 0,
      sommePending: 0,
    };
  },
  filters: {
    formatdate: function (date) {
      return dayjs(date).format("DD/MM/YYYY");
    },
    onemonthlater: function (date) {
      return dayjs(date).add(1, "month").format("DD/MM/YYYY");
    },
  },
  components: {
    VueGoodTable,
  },
  props: {
    disable_doc: {
      type: Boolean,
      default: false,
    },
    points: {
      type: Boolean,
      default: false,
    },
    subid: {
      type: String,
    },
    uid: {
      type: String,
    },
    opid: {
      type: String,
    },
  },
  async mounted() {
    try {
      this.paginationOptions = {
        firstLabel: "Premiére page",
        lastLabel: "Derniére page",
        nextLabel: "Suivant",
        prevLabel: "Précédent",
        rowsPerPageLabel: "Résultats par page",
        ofLabel: "sur",
        pageLabel: "page",
        allLabel: "Tout",
        enabled: true,
        perPage: 100,
        position: "top",
        perPageDropdown: [10, 20, 50, 100],
      };

      console.log(this.opid, this.subid, "-------------");

      let data = await axios.get(
        `https://api-gabarit.promo.dev/api/operations-custom/platform-v2-invoice/invoices/${this.opid}/${this.subid}`
      );

      if (!data) {
        return;
      }
      const facts = data.data;
      let somme = 0;
      let sommeP = 0;
      let totalmount = 0;
      facts.forEach((fact) => {
        if (fact.participationValide === "REFUND_DONE") {
          totalmount += fact.amount_to_refund;
          fact.prix_produits.forEach((prix_produit) => {
            somme += prix_produit.quantity;
          });
        }
        if (fact.participationValide === "VALID") {
          totalmount += fact.amount_to_refund;
          fact.prix_produits.forEach((prix_produit) => {
            sommeP += prix_produit.quantity;
          });
        }
      });

      this.sommeValid = somme;
      this.sommePending = sommeP;
      this.remaining = 100 - (somme + sommeP);
      if (totalmount >= 240000) {
        this.remaining = 0;
      }

      facts.sort((a, b) => {
        return new Date(b.date) - new Date(a.date);
      });
      this.facts = facts;

      this.columns = [
        {
          label: "Date",
          field: "date",
          type: "string",
          sortable: false,
        },
        {
          label: "Référence",
          field: "uid",
          type: "string",
          sortable: false,
        },

        {
          label: "Ticket de caisse",
          field: "receipt",
          type: "string",
          sortable: false,
        },
        {
          label: "status",
          field: "participationValide",
          type: "string",
          sortable: false,
        },

        {
          label: "Motif",
          field: "motif_nc",
          type: "string",
          sortable: false,
        },
        {
          label: "Quantité",
          field: "quantity",
          type: "string",
          sortable: false,
        },
        {
          label: "Remboursement",
          field: "prix_produits",
          type: "string",
          sortable: false,
        },
      ];

      if (this.disable_doc) {
        this.columns = [...this.columns.slice(0, 2), ...this.columns.slice(3)];
      }

      if (this.points) {
        this.columns = [
          ...this.columns,
          {
            label: "Points",
            field: "points",
            type: "string",
            sortable: false,
          },
        ];
      }
    } catch (e) {
      console.log(e);
      return;
    }
  },
  methods: {
    calculateTotalQuantity(prix_produits) {
      return prix_produits.reduce(
        (sum, product) => sum + (product.quantity || 0),
        0
      );
    },
    formatEUR(amount) {
      const euro = new Intl.NumberFormat("fr-FR", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2,
      });
      return euro.format(amount);
    },
    formatStatus(value) {
      if (value == "PENDING" || value == "FRAUD")
        return `<span class="bg-yellow-200 text-yellow-800 p-1 px-2 rounded-xl text-sm">EN ATTENTE</span>`;
      if (value == "VALID")
        return `<span class="bg-green-200 text-green-800 p-1 px-2 rounded-xl text-sm">VALIDE</span>`;
      if (value == "INVALID")
        return `<span class="bg-red-200 text-red-800 p-1 px-2 rounded-xl text-sm">INVALIDE</span>`;
      if (value == "REFUND_DONE")
        return `<span class="bg-green-200 text-green-800 p-1 px-2 rounded-xl text-sm">REMBOURSÉ</span>`;
      if (value == "MISSING")
        return `<span class="bg-red-200 text-red-800 p-1 px-2 rounded-xl text-sm">INVALIDE</span>`;
      return value;
    },
  },
};
</script>

<style>
.vgt-wrap__footer {
  @apply rounded-t-lg;
  background-color: white !important;
}
.vgt-wrap__footer {
  font-size: 14px !important;
  border: none !important;
  border-radius: 10px !important;
  padding: 8px !important;
  margin-bottom: 20px;
}

.footer__navigation.vgt-pull-right,
.footer__row-count__label,
.footer__row-count__select,
.footer__navigation__page-btn span {
  font-size: 14px !important;
}

.table.vgt-table,
.table.tbody,
.vgt-table.bordered th {
  border: none !important;
}

.vgt-inner-wrap {
  box-shadow: none !important;
}

tr th {
  background: white !important;
  border: none !important;
  border-bottom: solid 1px #e2e8f0 !important;
}

table.vgt-table {
  border: none !important;
}

tr th:first-child,
tr td:first-child {
  padding-left: 0 !important;
}
</style>

<style lang="scss" scoped>
.point {
  @apply m-auto w-7 h-7 flex justify-center items-center left-3 lg:left-6 bg-blue-500 rounded-full font-black text-2xl text-white top-2/4;
  transform: translate(-50%, -50%);
}

.entetes {
  @apply w-32 bg-blue-500 text-white text-sm text-center mb-8 z-10 relative;

  .th {
    @apply p-2 border-b-2 border-white h-16 flex justify-center items-center;
  }
}

.table_wrapper {
  @apply absolute overflow-auto flex flex-wrap left-36 top-0 w-full;
}

.table_item {
  @apply p-2 border-b-2 border-white h-16  w-52;
}

#box {
  @apply absolute top-0 left-0 w-full clear-both p-0 m-0 pl-32 overflow-y-visible overflow-x-auto z-0 whitespace-nowrap align-text-top;
}
.item {
  @apply table-cell w-36 whitespace-normal;
  min-width: 240px;

  .th {
    @apply text-sm p-2 border-b-2 border-white h-16 flex justify-center items-center bg-gray-100;
  }
}
</style>
